// OS browser toolbar size which includes sizes of tabs, url bar, bookmarks bar
// These values should be reviewed every 6-12 months when new devices or browsers are released
export const OS_BROWSER_TOOLBAR_SIZE: Record<string, number> = {
    // iPhone
    'iOS-Mobile Safari': 193,
    'iOS-Chrome': 187,
    'iOS-Firefox': 0,
    'iOS-Opera': 0,
    // iPad
    'iOS-Mobile Safari-tablet': 107,
    'iOS-Chrome-tablet': 119,
    // MacOS desktop
    'Mac OS-Safari': 103,
    'Mac OS-Chrome': 121,
    'Mac OS-Firefox': 113,
    'Mac OS-Edge': 118,
    'Mac OS-Opera': 123,
    // Android
    'Android-Chrome': 0,
    'Android-Edge': 0,
    'Android-Samsung Internet': 0,
    'Android-Firefox': 65,
    'Android-Opera': 0,
    // Android tablet
    'Android-Chrome-tablet': 0,
    'Android-Edge-tablet': 0,
    'Android-Samsung Internet-tablet': 0,
    'Android-Firefox-tablet': 66,
    // Windows
    'Windows-Chrome': 129,
    'Windows-Firefox': 129,
    'Windows-Edge': 127,
    'Windows-Opera': 99,
};
